<template>
    <div>
        <h1>My Profile</h1>
    </div>
</template>

<script>
    export default {
        name: 'profile-view',
    };
</script>

<style scoped>

</style>
